import Config from '@/config'
import { logger } from '@/lib/logger'
import type { ApisauceInstance } from 'apisauce'
import { create } from 'apisauce'
import { authRequestInterceptor } from './interceptors/auth'
import type { PatientReferral } from './types/MarketingApi'

export class MarketingApi {
	_apiConfig: ApisauceInstance

	constructor() {
		this._apiConfig = create({
			baseURL: Config.MARKETING_API_URL_BASE,
			timeout: 10000,
		})

		this._apiConfig.axiosInstance.interceptors.request.use(authRequestInterceptor)
	}

	fetchPatientReferral() {
		return this._apiConfig
			.get('/referrers/patient-referral')
			.then((response) => response.data as PatientReferral)
			.catch((error) => {
				logger.error(new Error('failed_to_get_referral_info', { cause: error }))
				return null
			})
	}
}

export const marketingApi = new MarketingApi()
